/**
 * Roads inside the property perimeter.
 *
 * Each road is a straight segment between two endpoints, with a given
 * width and an "inside" side (which half of the centerline the road
 * occupies). Endpoints can be either an existing reference point
 * (`{ refId: 'ref-2' }`) or an arbitrary lon/lat coordinate (for
 * computed endpoints like a parallel extension of another road).
 */

import type { RefPoint } from './refPoints';

export type RoadSide = 'left' | 'right' | 'center';

export type RoadEnd =
  | { refId: RefPoint['id'] }
  | { lon: number; lat: number };

export interface Road {
  id: string;
  from: RoadEnd;
  to: RoadEnd;
  widthM: number;
  /**
   * Which side of the from→to direction the road occupies:
   * - `right`: extends `widthM` to the right of the centerline.
   * - `left`: extends `widthM` to the left.
   * - `center`: centered on the line (widthM/2 each side).
   */
  side: RoadSide;
}

/**
 * Streets between the lot rows. One street sits before each row, matching the
 * lot layout: street / C / street / B / street / A. GENERATED alongside the
 * lots by scripts/generate-lots.mjs from the same P2/P11/P1 anchors + street
 * width — do not hand-edit the block between the markers. Run
 * `npm run generate:lots` to recompute. See docs/lots-geometry.md.
 */
export const ROADS: Road[] = [
  // <generated:streets> — do not edit by hand; run `npm run generate:lots`
  {
    id: 'street-c',
    from: { lon: -63.9933126, lat: 10.8998685 },
    to:   { lon: -63.9771300, lat: 10.9031643 },
    widthM: 12,
    side: 'center',
  },
  {
    id: 'street-b',
    from: { lon: -63.9930589, lat: 10.8980589 },
    to:   { lon: -63.9778498, lat: 10.9011564 },
    widthM: 12,
    side: 'center',
  },
  {
    id: 'street-a',
    from: { lon: -63.9927927, lat: 10.8961598 },
    to:   { lon: -63.9808144, lat: 10.8985993 },
    widthM: 12,
    side: 'center',
  },
  // </generated:streets>
];
